export default __webpack_public_path__ + "static/media/lock.090927c7.svg";